module.exports = __webpack_public_path__ + "img/howto.2e1e0566.png";